import { Inject, Injectable, DOCUMENT } from '@angular/core';


export interface JsonLd {
  // tslint:disable-next-line:ban-types
  [param: string]: string | Object;
}

@Injectable({
  providedIn: 'root',
})
export class JsonLdService {
  private jsonLd: JsonLd | JsonLd[];

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  setData(data: JsonLd | JsonLd[]): void {
    this.jsonLd = data;
    this.injectBrowser();
  }

  getObject(
    type: string,
    rawData?: JsonLd,
    context = 'http://schema.org',
  ): JsonLd {
    let object: JsonLd = {
      '@type': type,
    };
    if (context) {
      object = {
        '@context': context,
        ...object,
      };
    }
    if (rawData) {
      object = {
        ...object,
        ...rawData,
      };
    }
    return object;
  }

  toJson(): string {
    return JSON.stringify(this.jsonLd);
  }

  private injectBrowser(): void {
    let ldJsonScriptTag = this.document.head.querySelector(
      `script[type='application/ld+json']`,
    );

    if (ldJsonScriptTag) {
      ldJsonScriptTag.textContent = JSON.stringify(this.jsonLd);
    } else {
      ldJsonScriptTag = this.document.createElement('script');
      ldJsonScriptTag.setAttribute('type', 'application/ld+json');
      ldJsonScriptTag.textContent = JSON.stringify(this.jsonLd);
      this.document.head.appendChild(ldJsonScriptTag);
    }
  }
}
